import type { LoginResponse } from '@pgway/shared';

const SESSION_TOKEN_KEY = 'ssm_access_token';
const SESSION_USER_KEY = 'ssm_user';

// In-memory cache — sessionStorage is the persistent backing store
let accessToken: string | null = null;
let currentUser: LoginResponse['user'] | null = null;

// Initialise from sessionStorage on module load (handles page refresh)
try {
  const storedToken = sessionStorage.getItem(SESSION_TOKEN_KEY);
  const storedUser = sessionStorage.getItem(SESSION_USER_KEY);
  if (storedToken) {
    accessToken = storedToken;
  }
  if (storedUser) {
    currentUser = JSON.parse(storedUser) as LoginResponse['user'];
  }
} catch {
  // sessionStorage unavailable — fall back to memory-only
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
  try {
    if (token) {
      sessionStorage.setItem(SESSION_TOKEN_KEY, token);
    } else {
      sessionStorage.removeItem(SESSION_TOKEN_KEY);
    }
  } catch {
    // ignore
  }
}

export function getCurrentUser(): LoginResponse['user'] | null {
  return currentUser;
}

export function setCurrentUser(user: LoginResponse['user'] | null): void {
  currentUser = user;
  try {
    if (user) {
      sessionStorage.setItem(SESSION_USER_KEY, JSON.stringify(user));
    } else {
      sessionStorage.removeItem(SESSION_USER_KEY);
    }
  } catch {
    // ignore
  }
}

export function clearAuth(): void {
  accessToken = null;
  currentUser = null;
  try {
    sessionStorage.removeItem(SESSION_TOKEN_KEY);
    sessionStorage.removeItem(SESSION_USER_KEY);
  } catch {
    // ignore
  }
}

export function isAuthenticated(): boolean {
  return accessToken !== null;
}
